import React from 'react'
import { Text, View } from 'styles/reactnative'

const SettingTitle = ({ title, style }: any) => {
	return (
		<View
			style={{
				height: 45,
				width: '100%',
				borderBottom: '1px solid #ddd',
				...style,
			}}>
			<Text>{title}</Text>
		</View>
	)
}

export default SettingTitle
